// src/Education.js
import React from 'react';
import { Typography } from '@mui/material';
import { Timeline, TimelineItem, TimelineSeparator, TimelineDot, TimelineConnector, TimelineContent, TimelineOppositeContent } from '@mui/lab';
import SchoolIcon from '@mui/icons-material/School';
import educationData from '../Data/EducationData';

const Education = () => (
    <Timeline position="alternate">
        {educationData.map((education, index) => (
            <TimelineItem key={index}>
                <TimelineOppositeContent sx={{ m: 'auto 0' }} align="right" variant="body2" color="text.secondary">
                    {education.date}
                </TimelineOppositeContent>
                <TimelineSeparator>
                    <TimelineDot color="primary">
                        <SchoolIcon />
                    </TimelineDot>
                    {index < educationData.length - 1 && <TimelineConnector />}
                </TimelineSeparator>
                <TimelineContent sx={{ py: 2, px: 2 }}>
                    <Typography variant="h6" component="span" fontWeight="bold">
                        {education.institution}
                    </Typography>
                    <Typography variant="subtitle2" color="text.secondary">
                        {education.degree}
                    </Typography>
                    <Typography variant="body2">{education.description}</Typography>
                </TimelineContent>
            </TimelineItem>
        ))}
    </Timeline>
);

export default Education;
